const _ = require('lodash');
import { uuid } from 'vue-uuid';

export class Utils {

    static isNullOrUndefined(object) {
        if ((object == null) || (typeof (object) === "undefined")) {
            return true;
        }
        return false;
    }

	static isNullOrUndefinedOrEmpty(object) {
        if ((object == null) || (typeof (object) === "undefined")) {
            return true;
        }

		//if (object instanceof String) {
		if (typeof object === "string") {
			if ("" === object.trim()) {
				return true;
			}
		}

        return false;
    }

	/**
	 * Verifica che la stringa sia empty
	 * @param string
	 * @returns {Boolean}
	 */
	 static isEmpty = function(string) {
		if (!Utils.isNullOrUndefined(string)) {
			if ("" === string.trim()) {
				return true;
			}
		}
		return false;
	};
	

	/**
	 * Verifica che la stringa non sia vuota
	 * @param string
	 * @returns {Boolean}
	 */
	 static isNotEmpty = function(string) {
		if (!Utils.isNullOrUndefined(string)) {
			if ("" != string.trim()) {
				return true;
			}
		}
		return false;
	};

	/**
	 * Verifica che una lista non sia vuota
	 * @param string
	 * @returns {Boolean}
	 */
	 static isListNotEmpty = function(lst) {
		if (Utils.isNullOrUndefined(lst)) {
			return false;
		}
		
		if (!Array.isArray(lst)) {
			return false;
		}

		return (lst.length > 0);
	};

	/**
	 * Verifica che il valore sia "true"
	 * @param object
	 * @returns {Boolean}
	 */
	static isTrue = function(object) {
		if (!Utils.isNullOrUndefined(object) && object === true) {
			return true;
		}
		return false;
	};

	/**
	 * Verifica che il valore sia "true"
	 * @param object
	 * @returns {Boolean}
	 */
	 static isTrueLoose = function(object) {
		if (!Utils.isNullOrUndefined(object) && (object == true || object == 'true' )) {
			return true;
		}

		return false;
	};

	/**
	 * Verifica che il valore sia "false"
	 * @param object
	 * @returns {Boolean}
	 */
	 static isFalse = function(object) {
		if (!Utils.isNullOrUndefined(object) && object === false) {
			return true;
		}
		return false;
	};

	/**
	 * Verifica che il valore sia "false"
	 * @param object
	 * @returns {Boolean}
	 */
	 static isFalseLoose = function(object) {
		if (!Utils.isNullOrUndefined(object) && object == false) {
			return true;
		}
		return false;
	};


	/**
	 * intersection between two arrays
	 */
	static arrayIntersection = function(array_1, array_2) {
		if (Utils.isNullOrUndefined(array_1) || Utils.isNullOrUndefined(array_2)) {
			return new Array();
		}

		let intersection = array_1.filter(x => array_2.includes(x));
		return intersection;
	};

	/**
	 * Diff between two arrays
	 */
	static arrayDifference = function(array_1, array_2) {
		if (Utils.isNullOrUndefined(array_1)) {
			return new Array();
		}

		if (Utils.isNullOrUndefined(array_2)) {
			return array_1
		}

		let difference = array_1.filter(x => !array_2.includes(x));
		return difference;
	};

    /**
	 * Restituisce un tree a partire da una array lineare
	 * tenendo conto della relazione tra gli elementi data
	 * dall'attributo: parentId
	 * 
	 * Per poter funzionare la lista di oggetti deve conetente almeno i due attributi:
	 * - id
	 * - parentId
	 * 
	 * I parametri parent e tree verranno passati al metodo solo durante l'iterazione
	 * quindi basterà lanciare il metodo con il solo parametro "array
	 */
	static arrayToTree(array, parent, tree, extraRootNode) {
		tree = !Utils.isNullOrUndefined(tree) ? tree : [];
	
		//var parentNodeId = 0;
		var parentNodeId = null;
		if(!Utils.isNullOrUndefined(extraRootNode) && extraRootNode){
			//parentNodeId = -1;
			parentNodeId = null;
		}
		
		parent = !this.isNullOrUndefined(parent) ? parent : { id: parentNodeId };
		
		// Filtra la lista di elementi che hanno come parentId l'id del parent
		// Nel caso di parent null (primo livello di iterazione) i figli
		// saranno quelli con parentId = 0 ("null" o null)
		var children = array.filter(function(child) {
			return child.parentId === parent.id;
		});
		
		parent.children = [];
		
		if(!Utils.isEmptyObject(children)) {
			
			// Se primo livello di iterazione (primo livello tree) 
			// il tree equivale ai children trovati 
			// ( lista elementi con parentId = 0 o parentId = null )
			if( parent.id === parentNodeId ){
				tree = children;   
			} 
			// Nel caso di livelli successivi (diversi da 0) la lista di elementi figli
			// trovati viene agganciata al nodo "parent"
			else {
				parent.children = children;
			}  
				
			// Per ciascun elemento children trovato (elementi appartenenti ad un nodo)
			// Richiama ricorsivamente la presente funzione con la lista completa e 
			// il nodo child come nuovo parent per la nuova iterazione
			children.forEach( (child) => {
				Utils.arrayToTree(array, child, null, extraRootNode);
			});
				
		}
		
		// Restituisce il tree complessivo
		return tree;
	}

	static orderTree(tree, attribute, nestedProperty) {
		// Ordina la lista secondo l'attributo specificato
		var orderedTree = Utils.orderByAttribute(tree, attribute, "asc");
	
		// Cicla su ciascun elemento della lista per ordinare gli elementi
		// dei livelli successivo (esecuzione ricorsiva)
		/*
		$.each(tree, function(index, element) {
			if(element.hasOwnProperty(nestedProperty) && element[nestedProperty].length > 0) {
				Utils.orderTree(element[nestedProperty], attribute, nestedProperty);
			}
		});
		*/

		for(let element of tree) {
			if(element.nestedProperty && element[nestedProperty].length > 0) {
				Utils.orderTree(element[nestedProperty], attribute, nestedProperty);
			}
		}
		
		// Restituisce il tree complessivo ordinato
		return orderedTree;
	}

	/**
	 *  Ordina un array di oggetti in funzione di un attributo
	 */
	static orderByAttribute(arr, attr, dir) {
		return arr.sort(Utils.compareValues(attr, dir));
	}

	/**
	 * Ordina una array di numeri
	 * @param array
	 */
	 static orderArrayNumber(array) {
		return array.sort(function(a, b){return a-b;});
	}

	static compareValues(attr, dir) {
		var sortOrder = 1;
		
		if(dir === "desc")
			sortOrder = -1;
	
		return function (a,b) {
			var result = (a[attr] < b[attr]) ? -1 : (a[attr] > b[attr]) ? 1 : 0;
			return result * sortOrder;
		};
	}

	static getElementWithMinValueProperty(array, attribute1, attribute2) {
		let map = array.map((element) => {
			return element[attribute1][attribute2];
		});

		let minValue = _.min(map);

		
		for(let [index, element] of array.entries()) {
			if(element[attribute1][attribute2] != minValue) {
				array.splice(index, 1);
			}
		}

		return array; 
	}

	static getParamsFromUrl(url) {
		// Prende solo la parte di url dopo il punto interrogativo
		// (query string)
		var params = {};
		
		if(url.indexOf("?") === -1) {
			return params;
		}
		
		var queryString = url.slice(url.indexOf("?") + 1);
		var paramsKeyValue = queryString.split("&");
		
		for(var i = 0; i < paramsKeyValue.length; i++) {
			var hash = paramsKeyValue[i].split("=");
			var key = hash[0];
			var value = hash[1];
			params[key] = value;
		}
		
		return params;
	}

    static parseFloat(value) {
		let parsedValue = parseFloat(value);
		if(parsedValue === 0) {
			return parsedValue;
		}
		return parsedValue.toFixed(2);
	}

	// static isElementObjInArray(element, array) {

	// 	if(Utils.isNullOrUndefined(array)) {
	// 		return false;
	// 	}

	// 	let matched = false;

	// 	let matchedElements = array.filter((arrayElement, oldIndex) => {
	// 		return arrayElement.id == element.id;
	// 	});

	// 	// Layer non presente nella lista vecchia --> DA AGGIUNGERE
	// 	if(matchedElements.length > 0) {
	// 		matched = true;
	// 	}

	// 	return matched;
	// }

	static cloneDeep(obj) {
		let cloneObj = _.cloneDeep(obj);
		return cloneObj;
	}

	static isEmptyObject(obj) {
		let isEmpty = _.isEmpty(obj);
		return isEmpty;
	}

	static pad(value, lenght) {
		let array = new Array(lenght);
		let valueString = array.join("0") + value;
		let slice = valueString.slice((lenght || 2) * -1);

		return slice;
	}

	static isArray(obj) {
		return _.isArray(obj);
	}

	static isEqual(obj1, obj2) {
		return _.isEqual(obj1, obj2);
	}

	static getIndexElement(array, attribute, value) {
		let index = null;

		array.forEach((element, idx) => {
			if(element[attribute] == value) {
				index = idx;
				return false;
			}
		});

		return index;
	}

	static humanFileSize(bytes, si=false, dp=1) {
		const thresh = si ? 1000 : 1024;

		if (Math.abs(bytes) < thresh) {
			return {
				value: 0,
				unit: 'B'
			}
		}

		const units = si 
			? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
			: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
		let u = -1;
		const r = 10**dp;

		do {
			bytes /= thresh;
			++u;
		} while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

		let size = {
			value: bytes.toFixed(dp),
			unit: units[u]
		}

		return size;
	}

	static getTransferSpeed(curTime, prevTime, curSize, prevSize) {
		if(
			Utils.isNullOrUndefined(curTime) || 
			Utils.isNullOrUndefined(prevTime) || 
			Utils.isNullOrUndefined(curSize) ||
			Utils.isNullOrUndefined(prevSize) ||
			isNaN(curTime) || 
			isNaN(prevTime) ||
			isNaN(curSize) || 
			isNaN(prevSize)
		 ) {
			return "0 b/s";
		}

		let timeDiffSec = (curTime - prevTime) / 1000;
		let sizeDiff = curSize - prevSize;
		//let humanSizeDiff = Utils.humanFileSize(sizeDiff);

		//console.log("Time Diff: " + timeDiffSec);
		//console.log("Sizes: " + curSize +  " " + prevSize);
		//console.log("Human Size Diff: " + humanSizeDiff.value + " " + humanSizeDiff.unit);

		let speedValue = sizeDiff / timeDiffSec;
		let humanSpeed = Utils.humanFileSize(speedValue);
		//console.log("Speed: " + humanSpeed.value + humanSpeed.unit);

		let speed = humanSpeed.value + " " + humanSpeed.unit + "/s";
		return speed;
	}

	static isMultiple(num, divisible) {
		if(isNaN(num) || isNaN(divisible)) {
			return false;
		}
		return (num % divisible === 0);
	}

	static generateGuid() {
		return uuid.v4();
	}

	static parseInteger(value) {
		let int = value.replace(/[^\d]*/g,'');
		return int;
	}

	static toFixedNumber(num, digits) {
		var pow = Math.pow(10, digits);
		return Math.round(num*pow) / pow;
	}

	static isSmartphoneorTablet() {
		let check = false;
		(function(a){
			if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) 
				check = true;
			}
		)(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	}

	static isSmartphone() {
		let check = false;
  		(function(a){
			if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4))) 
				check = true;
			}
		)(navigator.userAgent||navigator.vendor||window.opera);
  		return check;
	}
    
}